import React, { useState } from 'react';
import Formsy from 'formsy-react';
import { Button } from 'react-bootstrap/lib';
import numeral from 'numeral';
import TransferFormsy from './TransferFormsy';
import { ConfirmationTransfer } from './ConfirmationTransfer';
import API from '../../utils/api';

const TransferFormulario = ({ maxForTransfer, updateUserBalance, updateUserAvailable }) => {
  const [submitting, setSubmitting] = useState(false)
  const [canSubmit, setCanSubmit] = useState(false)
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [userToTransfer, setUserToTransfer] = useState(null)
  const [errorTransfer, setErrorTransfer] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [transferModel, setTransferModel] = useState({
    nickToTransfer: '',
    amountToTransfer: 0
  })

  const resetForm = () => {
    setUserToTransfer(null)
    setShowConfirmation(false)
    setErrorTransfer(false)
    setErrorMessage('')
  }

  const handleInputChange = (field) => (e) => {
    setTransferModel(prev => ({
      ...prev,
      [field]: e.target.value
    }))
  }

  const searchNick = async () => {
    setSubmitting(true)
    try {
      const response = await API.searchUser(transferModel.nickToTransfer)
      if (response.data?.user) {
        setUserToTransfer(response.data.user)
        setShowConfirmation(true)
      } else {
        setErrorTransfer(true)
        setErrorMessage('El usuario no existe.')
        setShowConfirmation(true)
      }
    } catch (error) {
      setErrorTransfer(true)
      setErrorMessage('Error al buscar usuario')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className='flex-col col-no-padding'>
      <Formsy
        onValidSubmit={() => setShowConfirmation(true)}
        onValid={() => setCanSubmit(true)}
        onInvalid={() => setCanSubmit(false)}
      >
        <div className='flex-container justify align column'>
          <div className='flex-col'>
            <TransferFormsy
              label='Escribe el nick del usuario al que le quieras transferir saldo.'
              name='nickToTransfer'
              value={transferModel.nickToTransfer}
              inputHandler={handleInputChange('nickToTransfer')}
              validations='isExisty'
              validationError='Campo requerido.'
              type='NICK'
              required
            />
          </div>
          <div className='flex-col'>
            <TransferFormsy
              label='Escribe el monto que quieres transferir.'
              name='amountToTransfer'
              value={transferModel.amountToTransfer}
              inputHandler={handleInputChange('amountToTransfer')}
              validations={{
                isEnoughRule: (values, value) => {
                  const maxValue = maxForTransfer / 100
                  return Number(value) <= maxValue && Number(value) >= 1
                }
              }}
              validationError={`El monto a transferir debe de ser de $1 a ${
                numeral(maxForTransfer / 100).format('$0,000')
              } MXN`}
              type='AMOUNT'
              required
            />
          </div>
        </div>

        <div className='flex-col'>
          <div className='flex-row' style={{ paddingLeft: '0', paddingRight: '0' }}>
            <Button
              className='btn-pick btn-search-field flex-col col-center text-center'
              disabled={!canSubmit || submitting}
              onClick={searchNick}
            >
              {submitting ? <i className='ion-load-a loading' /> : 'Buscar Usuario'}
            </Button>
          </div>
          <div className='flex-row'>
            <div className='flex-col'>
              <i className='ion-help-circled' /> Únicamente podrás transferir saldo retirable,
              desde $1 MXN hasta {numeral(maxForTransfer / 100).format('$0,000')} MXN.
            </div>
          </div>
          <div className='flex-row'>
            <div className='flex-col'>
              <i className='ion-help-circled' /> Podrás realizar una (1) transferencia cada 24hrs.
            </div>
          </div>
        </div>
      </Formsy>

      <ConfirmationTransfer
        closeConfirmation={() => {
          setShowConfirmation(false)
          resetForm()
        }}
        show={showConfirmation}
        error={errorTransfer}
        submitting={submitting}
        errorMessage={errorMessage}
        userToTransfer={userToTransfer}
        amountToTransfer={transferModel.amountToTransfer}
        updateUserBalance={updateUserBalance}
        updateUserAvailable={updateUserAvailable}
      />
    </div>
  )
}

export default TransferFormulario